export enum AngularMode {
    OLD_UI = 1,
    INTERNAL = 2,
    ALPHA = 3,
    BETA = 4,
    GA = 5
}
export enum AngularModeNames {
    OLD_UI = 'OLD UI',
    INTERNAL = 'INTERNAL',
    ALPHA = 'ALPHA',
    BETA = 'BETA',
    GA = 'GA'
}
export const AngularModeNameById = new Map<AngularMode | undefined, AngularModeNames>([
    [AngularMode.OLD_UI, AngularModeNames.OLD_UI],
    [AngularMode.INTERNAL, AngularModeNames.INTERNAL],
    [AngularMode.ALPHA, AngularModeNames.ALPHA],
    [AngularMode.BETA, AngularModeNames.BETA],
    [AngularMode.GA, AngularModeNames.GA]
]);
